export default __webpack_public_path__ + "static/media/116_arakgum.8e8a7490.webp";